import React, { useEffect, useState, useRef } from 'react';
import Header from '../../components/Header/Header';
import { baseUrl } from '../../Urls';
import '../Customer/customerpage.css';
import { FaEdit } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import TermPicker from '../../components/TermPicker/TermPicker';
import * as XLSX from "xlsx";
import { LuShrink } from "react-icons/lu";
import { IoExpand } from "react-icons/io5";
import ExpandableText from '../../components/ExpandableText/ExpandableText';

function Customer() {
    const [salesList, setSalesList] = useState([]);
    const [filteredSales, setFilteredSales] = useState([]);
    const [filters, setFilters] = useState({
        startDate: '',
        endDate: '',
        assignedTo: '',
    });
    const [loading, setLoading] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const [isSidebarOpen, setIsSidebarOpen] = useState(true);
    const navigate = useNavigate();
    const [editingCell, setEditingCell] = useState({ rowId: null, key: null });
    const [approvedByValue, setApprovedByValue] = useState('');
    const [assignedToValue, setAssignedToValue] = useState('');
    const [assignedByValue, setAssignedByValue] = useState('');
    const [proposalStatusActive, setProposalStatusActive] = useState(false);
    const isEditingRef = useRef(false);

    const fetchSales = async () => {
        try {
            setLoading(true);
            const res = await fetch(`${baseUrl}/api/sales`, {
                method: 'GET',
                credentials: 'include',
            });
            const data = await res.json();
            setSalesList(data);
        } catch (err) {
            console.error('Error fetching customer data:', err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchSales();
    }, []);

    const handlePoStatus = async (id, status) => {
        try {
            const res = await fetch(`${baseUrl}/api/sales/po-status/${id}`, {
                method: 'PUT',
                credentials: "include",
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ poStatus: status }),
            });

            if (res.ok) {
                fetchSales();
            } else {
                console.error('Status update failed');
            }
        } catch (err) {
            console.error('Error updating PO status:', err);
        }
    };
    const saveApprovedBy = async (id) => {
        try {
            const res = await fetch(`${baseUrl}/api/sales/approved-by/${id}`, {
                method: 'PUT',
                credentials: 'include',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ approvedBy: approvedByValue })
            });

            if (res.ok) {
                const updatedSale = await res.json();

                setSalesList(prev =>
                    prev.map(sale =>
                        sale._id === id ? { ...sale, approvedBy: updatedSale.approvedBy } : sale
                    )
                );
            } else {
                console.error('Failed to update approvedBy');
            }
        } catch (err) {
            console.error(err);
        } finally {
            setTimeout(() => {
                setEditingCell({ rowId: null, key: null });
            }, 50);
        }
    };
    const saveAssignedBy = async (id) => {
        try {
            const res = await fetch(`${baseUrl}/api/sales/approved-by/${id}`, {
                method: 'PUT',
                credentials: 'include',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ assignedBy: assignedByValue })
            });

            if (res.ok) {
                const updatedSale = await res.json();

                setSalesList(prev =>
                    prev.map(sale =>
                        sale._id === id ? { ...sale, assignedBy: updatedSale.assignedBy } : sale
                    )
                );
            } else {
                console.error('Failed to update assignedBy');
            }
        } catch (err) {
            console.error(err);
        } finally {
            setTimeout(() => {
                setEditingCell({ rowId: null, key: null });
            }, 50);
        }
    };
    const saveAssignedTo = async (id) => {
        try {
            const res = await fetch(`${baseUrl}/api/sales/approved-by/${id}`, {
                method: 'PUT',
                credentials: 'include',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ assignedTo: assignedToValue })
            });

            if (res.ok) {
                const updatedSale = await res.json();

                setSalesList(prev =>
                    prev.map(sale =>
                        sale._id === id ? { ...sale, assignedTo: updatedSale.assignedTo } : sale
                    )
                );
            } else {
                console.error('Failed to update assignedTo');
            }
        } catch (err) {
            console.error(err);
        } finally {
            setTimeout(() => {
                setEditingCell({ rowId: null, key: null });
            }, 50);
        }
    };

    const custColumns = [
        {
            key: 'edit',
            label: 'Edit',
            render: (sale) => (
                <FaEdit
                    style={{ cursor: "pointer", color: "gray" }}
                    // onClick={() => navigate('/sales', { state: { sale, from: 'customer' } })}
                    onClick={() => {
                        sessionStorage.setItem("lastEditedId", sale._id);
                        isEditingRef.current = true;
                        navigate('/sales', { state: { sale, from: 'customer' } })
                    }}
                />
            )
        },
        { key: 'sNo', label: 'S.No' },
        { key: 'date', label: 'Enq Date' },
        { key: 'companyName', label: 'Company Name' },
        { key: 'productName', label: 'Product Name' },
        { key: 'addressLine1', label: 'Address' },
        { key: 'contactPerson', label: 'Contact Person' },
        { key: 'phone', label: 'Phone' },
        { key: 'tel', label: 'Telephone' },
        { key: 'email', label: 'Email' },
        { key: 'scope', label: 'Scope', render: (sale) => <ExpandableText text={sale.scope} maxLines={2} />, },
        { key: 'source', label: 'Source' },
        {
            key: 'attachments',
            label: 'Lead Attachments',
            render: (sale) =>
                sale.attachments?.map((link, i) => (
                    <div key={i}>
                        <a href={link} target='_blank' rel='noopener noreferrer'>
                            View File {i + 1}
                        </a>
                    </div>
                )) || '-'
        },
        {
            key: 'assignedBy',
            label: 'Assigned By',
            render: (sale) => {
                const options = ['Vishnu', 'Amal', 'Sukesh Krishnan', 'Suresh', 'Thomas Philip', 'Vinayan Nambiar'];

                if (editingCell.rowId === sale._id && editingCell.key === 'assignedBy') {
                    return (
                        <select
                            value={assignedByValue}
                            onChange={(e) => setAssignedByValue(e.target.value)}
                            onBlur={() => saveAssignedBy(sale._id)}
                            autoFocus
                            style={{ width: '100%' }}
                        >
                            <option value="">Select</option>
                            {options.map((user) => (
                                <option key={user} value={user}>
                                    {user}
                                </option>
                            ))}
                        </select>
                    );
                }

                return (
                    <span
                        style={{ cursor: 'pointer' }}
                        onClick={() => {
                            setEditingCell({ rowId: sale._id, key: 'assignedBy' });
                            setAssignedByValue(sale.assignedBy || '');
                        }}
                    >
                        {sale.assignedBy || '-'}
                    </span>
                );
            }
        },
        {
            key: 'assignedTo',
            label: 'Assigned To',
            render: (sale) => {
                const options = ['Amal', 'Vishnu', 'Shobana Devi', 'Joe', 'Karthikeyan', 'Kavitha', 'Manimekalai', 'Suresh', 'Thomas Philip', 'Vinayan Nambiar', 'Sukesh Krishnan'];

                if (editingCell.rowId === sale._id && editingCell.key === 'assignedTo') {
                    return (
                        <select
                            value={assignedToValue}
                            onChange={(e) => setAssignedToValue(e.target.value)}
                            onBlur={() => saveAssignedTo(sale._id)}
                            autoFocus
                            style={{ width: '100%' }}
                        >
                            <option value="">Select</option>
                            {options.map((user) => (
                                <option key={user} value={user}>
                                    {user}
                                </option>
                            ))}
                        </select>
                    );
                }

                return (
                    <span
                        style={{ cursor: 'pointer' }}
                        onClick={() => {
                            setEditingCell({ rowId: sale._id, key: 'assignedTo' });
                            setAssignedToValue(sale.assignedTo || '');
                        }}
                    >
                        {sale.assignedTo || '-'}
                    </span>
                );
            }
        },
        { key: 'note', label: 'Note', render: (sale) => <ExpandableText text={sale.note} maxLines={2} />, },

        { key: 'estDate', label: 'EST Date', render: (sale) => sale.estDate || '-' },
        { key: 'quotationNo', label: 'Quotation No' },
        { key: 'estimator', label: 'Estimator' },
        {
            key: 'estAttachments',
            label: 'EST Sheet',
            render: (sale) =>
                sale.estAttachments?.map((link, i) => (
                    <div key={i}>
                        <a href={link} target='_blank' rel='noopener noreferrer'>
                            View File {i + 1}
                        </a>
                    </div>
                )) || '-'
        },
        {
            key: 'qutPdf',
            label: 'Quotation Proposal',
            render: (sale) =>
                sale.qutPdf?.map((link, i) => (
                    <div key={i}>
                        <a href={link} target='_blank' rel='noopener noreferrer'>
                            View File {i + 1}
                        </a>
                    </div>
                )) || '-'
        },
        {
            key: 'poStatus',
            label: 'Proposal Status',
            render: (sale) => {
                let displayStatus = sale.poStatus;

                if (!sale.poStatus || sale.poStatus === 'inProgress' || sale.poStatus === 'pending') {
                    if (sale.qutPdf && sale.qutPdf.length > 0) {
                        displayStatus = 'Pending';
                    } else {
                        displayStatus = 'inProgress';
                    }
                }
                const badgeClass = displayStatus === 'approved' ? 'bg-success' : displayStatus === 'rejected' ? 'bg-danger' : 'bg-warning text-dark';
                return (
                    <span className={`badge ${badgeClass}`}>
                        {displayStatus.charAt(0).toUpperCase() + displayStatus.slice(1)}
                    </span>
                );
            }
        },
        {
            key: 'managementAction',
            label: 'Proposal',
            render: (sale) => (
                <>
                    <button
                        className='btn btn-success btn-sm me-2'
                        onClick={() => handlePoStatus(sale._id, 'approved')}
                    >
                        Approve
                    </button>
                    <button
                        className='btn btn-danger btn-sm'
                        onClick={() => handlePoStatus(sale._id, 'rejected')}
                    >
                        Deny
                    </button>
                </>
            )
        },
        {
            key: 'approvedBy',
            label: 'Approved By',
            render: (sale) => {
                const options = ['Amal', 'Vishnu', 'Sukesh Krishnan', 'Suresh', 'Thomas Philip', 'Vinayan Nambiar'];

                if (editingCell.rowId === sale._id && editingCell.key === 'approvedBy') {
                    return (
                        <select
                            value={approvedByValue}
                            onChange={(e) => setApprovedByValue(e.target.value)}
                            onBlur={() => saveApprovedBy(sale._id)}
                            autoFocus
                            style={{ width: '100%' }}
                        >
                            <option value="">Select</option>
                            {options.map((user) => (
                                <option key={user} value={user}>
                                    {user}
                                </option>
                            ))}
                        </select>
                    );
                }

                return (
                    <span
                        style={{ cursor: 'pointer' }}
                        onClick={() => {
                            setEditingCell({ rowId: sale._id, key: 'approvedBy' });
                            setApprovedByValue(sale.approvedBy || '');
                        }}
                    >
                        {sale.approvedBy || '-'}
                    </span>
                );
            }
        }
    ];
    const handleDateFilter = (e) => {
        const { name, value } = e.target;
        setFilters(prev => ({ ...prev, [name === 'start' ? 'startDate' : 'endDate']: value }));
    };

    useEffect(() => {
        let filtered = [...salesList];

        if (filters.startDate && filters.endDate) {
            const start = new Date(filters.startDate);
            const end = new Date(filters.endDate);
            end.setMonth(end.getMonth() + 1);
            end.setDate(0);
            end.setHours(23, 59, 59, 999);

            filtered = filtered.filter(sale => {
                const enqDate = new Date(sale.date);
                return enqDate >= start && enqDate <= end;
            });
        }

        if (filters.assignedTo) {
            filtered = filtered.filter(sale => sale.assignedTo === filters.assignedTo);
        }

        // ⭐ Proposal Status sort (ADD HERE)
        if (proposalStatusActive) {
            filtered = [...filtered].sort((a, b) => {
                const getStatus = (sale) => {
                    if (
                        !sale.poStatus ||
                        sale.poStatus === 'pending' ||
                        sale.poStatus === 'inProgress'
                    ) {
                        return sale.qutPdf?.length ? 'pending' : 'inProgress';
                    }
                    return sale.poStatus;
                };

                const order = {
                    approved: 0,
                    rejected: 1,
                    inProgress: 2,
                    pending: 3
                };

                return (
                    (order[getStatus(a)] ?? 99) -
                    (order[getStatus(b)] ?? 99)
                );
            });
        }

        // ✅ FINAL state update
        setFilteredSales(filtered);
    }, [filters, salesList, proposalStatusActive]);

    const handleAssignedToFilter = (assignedTo) => {
        setFilters(prev => ({
            ...prev,
            assignedTo: prev.assignedTo === assignedTo ? '' : assignedTo
        }));
    }

    const exportToExcel = () => {
        if (!filteredSales.length) {
            alert("No data to export!");
            return;
        }

        const worksheet = XLSX.utils.json_to_sheet([...filteredSales].map(sale => ({
            "SNo": sale.sNo,
            "Enq Date": sale.date,
            "Company Name": sale.companyName,
            "Product Name": sale.productName,
            "Address": sale.addressLine1,
            "Contact Person": sale.contactPerson,
            "Phone": sale.phone,
            "Telehone": sale.tel,
            "Email": sale.email,
            "Scope": sale.scope,
            "Source": sale.source,
            "Attachments": sale.attachments?.length ? sale.attachments.join(", ") : "-",
            "Assigned by": sale.assignedBy,
            "Assigned to": sale.assignedTo,
            "Note": sale.note,
            "EST Date": sale.estDate || "-",
            "Quotation No": sale.quotationNo,
            "Estimator": sale.estimator,
            "Est Sheet": sale.estAttachments?.length ? sale.estAttachments.join(", ") : "-",
            "Quotation Proposal": sale.qutPdf?.length ? sale.qutPdf.join(", ") : "-",
            "Proposal Status": sale.poStatus,
            "Follow-Up-1": sale.soDate || "-",
            "Note-1": sale.soNote || "-",
            "Follow-Up-2": sale.soDateTwo || "-",
            "Note-2": sale.soNoteTwo || "-",
            "Follow-Up-3": sale.soDateThree || "-",
            "Note-3": sale.soNoteTHree || "-",
            "Status": sale.status,
            "Amount": sale.amount,
            "PO Attcahments Link": sale.poAttachments?.length ? sale.poAttachments.join(", ") : "-",
            "Reason": sale.reason,
        })));
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "SalesOrders");
        const fileName = `SalesOrders${filters.assignedTo ? `_${filters.assignedTo}` : ""}.xlsx`;
        XLSX.writeFile(workbook, fileName);
    }

    const tableContainerRef = useRef(null);

    useEffect(() => {
        if (!filteredSales.length || !tableContainerRef.current) return;
        const editedId = sessionStorage.getItem("lastEditedId");
        if (editedId) {
            // 🟢 Coming back from edit
            isEditingRef.current = true;
            // 🕒 Wait a bit to ensure table rows are rendered
            setTimeout(() => {
                const rowElement = document.getElementById(`row-${editedId}`);
                if (rowElement) {
                    rowElement.scrollIntoView({ behavior: "smooth", block: "center" });
                    rowElement.classList.add("highlight-row");
                    setTimeout(() => rowElement.classList.remove("highlight-row"), 2000);
                }
                sessionStorage.removeItem("lastEditedId");
            }, 500);
        } else if (!isEditingRef.current) {
            requestAnimationFrame(() => {
                const container = tableContainerRef.current;
                if (!container) return;
                container.scrollTop = container.scrollHeight;
            });
        }
    }, [filteredSales]);
    return (
        <>
            <Header salesList={salesList} />
            <div className="container customer-container" style={{ marginTop: "100px" }}>
                <h2 className='customer-heading'>Assign Page</h2>
                <span
                    className="toggle-icon"
                    onClick={() => setIsSidebarOpen(!isSidebarOpen)}
                    style={{ width: "40px" }}
                >
                    {isSidebarOpen ? <IoExpand /> : <LuShrink />}
                </span>
                <div className='row mt-3'>
                    {isSidebarOpen && (
                        <div className='col-lg-3 col-md-4 mb-2 order-2 order-md-2 order-lg-1 exportcolumn'>
                            <button className='exp-btn' type="button" onClick={exportToExcel}>Export</button>
                            <div className='mb-2'>
                                <h6 className='status-title'>Filter by Assigned To</h6>
                                {['Vishnu', 'Amal', 'Shobana Devi', 'Karthikeyan', 'Joe', 'Kavitha', 'Manimekalai', 'Suresh', 'Thomas Philip', 'Vinayan Nambiar', 'Sukesh Krishnan'].map(user => (
                                    <div className="form-check" style={{ color: "white" }} key={user}>
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            id={`assignedTo-${user}`}
                                            checked={filters.assignedTo === user}
                                            onChange={() => handleAssignedToFilter(user)}
                                        />
                                        <label className="form-check-label">
                                            {user}
                                        </label>
                                    </div>
                                ))}
                            </div>
                            <TermPicker
                                startName="start"
                                endName="end"
                                onChange={handleDateFilter}
                            />
                        </div>
                    )}
                    <div
                        className={`table-container-customer ${isSidebarOpen ? 'col-lg-9 col-md-8' : 'col-12'} order-1 order-md-1 order-lg-2 p-0`}
                        ref={tableContainerRef}
                    >
                        {loading ? (
                            <div className="spinner-container">
                                <div className="spinner"></div>
                                <p>Loading customer data...</p>
                            </div>
                        ) : (
                            <table className="table table-bordered customer-table table-hover" style={{ fontSize: "14px" }}>
                                <thead>
                                    <tr>
                                        {custColumns.map(col => (
                                            <th
                                                key={col.key}
                                                style={{ cursor: col.key === 'poStatus' ? 'pointer' : 'default' }}
                                                onClick={() => {
                                                    if (col.key === 'poStatus') {
                                                        setProposalStatusActive(prev => !prev);
                                                    }
                                                }}
                                            >
                                                {col.label}
                                                {col.key === 'poStatus' && (
                                                    <span style={{ marginLeft: 6 }}>
                                                        {proposalStatusActive ? '⬆' : ''}
                                                    </span>
                                                )}
                                            </th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredSales.length === 0 ? (
                                        <tr>
                                            <td colSpan={custColumns.length} className="text-left text-dark">
                                                No customer data found
                                            </td>
                                        </tr>
                                    ) : (
                                        filteredSales.map(sale => (
                                            <tr
                                                id={`row-${sale._id}`}
                                                key={sale._id}
                                                onClick={() => setSelectedRow(selectedRow === sale._id ? null : sale._id)}
                                                className={selectedRow === sale._id ? 'highlight-row' : ''}
                                                style={{ cursor: "pointer" }}
                                            >
                                                {custColumns.map((col) => (
                                                    <td key={col.key}>
                                                        {col.render ? col.render(sale) : sale[col.key] ?? '-'}
                                                    </td>
                                                ))}
                                            </tr>
                                        ))
                                    )}
                                </tbody>
                            </table>
                        )}
                    </div>
                </div>
            </div>
        </>
    )
}

export default Customer